import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Control, FieldPathByValue, RegisterOptions } from "react-hook-form";
import { CountryCode } from "react-native-country-picker-modal";

import { TextInputProps as CustomTextInputProps } from "../../components";
import { DEFAULT_COUNTRY_LABEL } from "../../components/AddressAutoComplete/types";
import { AddressFields as AddressFields$ } from "../../components/AddressAutoComplete/placeToFormData";

export type AccountStackParamList = {
  AccountSettings: undefined;
  AccountShow: undefined;
  JobPreferences: undefined;
  EmailChange: undefined;
  Jobs: undefined;
  AccountEdit: undefined;
  AccountEditContactInformation: undefined;
  AddEmployment: undefined;
  AssumeUser: undefined;
};

export type ScreenProps<name extends keyof AccountStackParamList> = NativeStackScreenProps<
  AccountStackParamList,
  name,
  "account"
>;

export interface TextInputProps extends Omit<CustomTextInputProps, "theme"> {
  name: FieldPathByValue<FormData, string>;
  control: Control<FormData>;
  rules?: RegisterOptions;
  countryField?: "home.country" | "secondary.country";
  errorClassName?: string;
}

export interface AddressFields extends AddressFields$ {
  country: string;
}

export interface FormData {
  home: AddressFields;
  secondary: AddressFields;
  homePhone: string;
  mobilePhone: string;
  homePhoneCountryCode: CountryCode;
  mobilePhoneCountryCode: CountryCode;
}

export const defaultAddressFields: AddressFields = {
  address: "",
  address2: "",
  city: "",
  state: "",
  postalCode: "",
  country: DEFAULT_COUNTRY_LABEL,
};

export const defaultValues: FormData = {
  home: defaultAddressFields,
  secondary: defaultAddressFields,
  homePhone: "",
  mobilePhone: "",
  homePhoneCountryCode: "US",
  mobilePhoneCountryCode: "US",
};
